import { render, staticRenderFns } from "./WPProgressBar.vue?vue&type=template&id=50610b86"
import script from "./WPProgressBar.vue?vue&type=script&lang=ts"
export * from "./WPProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./WPProgressBar.vue?vue&type=style&index=0&id=50610b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports